import type { StackedNumbersList } from 'src/components/followUp/common/types';

import type { NpsQuestionBarProps } from './constants';

export type QuestionBarsWithLabel = Array<
  NpsQuestionBarProps & { question: string }
>;

export const transformNpsData = (
  data?: StackedNumbersList,
): QuestionBarsWithLabel | null =>
  data
    ? data.results.map(({ label, stacks }) => ({
        question: label,
        passive:
          stacks.find((stack) => stack.stackLabel === 'passive')?.value ?? 0,
        detractor:
          stacks.find((stack) => stack.stackLabel === 'detractor')?.value ?? 0,
        promoter:
          stacks.find((stack) => stack.stackLabel === 'promoter')?.value ?? 0,
        notAnswered:
          stacks.find((stack) => stack.stackLabel === 'n/a')?.value ?? 0,
      }))
    : null;
